/* @flow */
import { getterFromKeyPath } from 'trustar/utils';
import { createSelector } from 'reselect';
import { Map } from 'immutable';

import { redactionMap } from 'modules/redaction/getters.js';
import { redactAll } from 'trustar/utils/utils.js';
import { defang } from 'trustar/reports/defang';

export const currentStage = getterFromKeyPath(['create', 'currentStage']);

export const submissionType = getterFromKeyPath(['create', 'submissionType']);

export const applyRedaction = getterFromKeyPath(['create', 'applyRedaction']);

export const attachFileLoading = getterFromKeyPath(['create', 'attachFileLoading']);

export const loading = getterFromKeyPath(['create', 'loading']);

export const formValues = getterFromKeyPath(['create', 'form', 'currentValues']);

export const emailableContent = createSelector(
  [ formValues, redactionMap ],
  (report: Map<string, string>, redactionMap: Map<any, any>): Map<string, string> => {
    if (!report) return Map({ reportTitle: '', reportContent: '' });
    const values = redactAll({ report, redactionMap, toHash: false });
    if (!values) return Map({ reportTitle: '', reportContent: '' });
    const title = values.get('title');
    const content = values.getIn(['content', 'data']);

    const reportTitle = title && encodeURIComponent(defang(`Incident Report: ${title}`));

    const divider = '-----------------------------';
    const truStarAd = `${divider}\n\nTo learn more and join TruSTAR go to www.trustar.co\n\n${divider}\n\n`;

    // to preserve all the formatting in the email body, we should use encodeURIComponent

    // encodeURIComponent vs encodeURI: encodeURIComponent will treat value as a value of a parameter in url and encode everything including
    // all the special characters, encodeURI will encode value as a url and not encode some special characters
    // such as ? & = because they are reserved keywords with some sort of functionalities.
    // So must use encodeURIComponent in case report content comes with characters not escaped by encodeURI

    const reportContent = content
      ? encodeURIComponent(`TruSTAR Incident Report Title: ${defang(title)}\n\n${defang(content)}\n\n\n${truStarAd}`)
      : '';

    return Map({
      reportTitle,
      reportContent,
    });
  },
);

export const redactedValues = createSelector(
  [ redactionMap, formValues ],
  (redactionMap: any, formValues: any) => {
    return redactAll({
      report: formValues,
      redactionMap: redactionMap,
      toHash: true,
    });
  }
);



// WEBPACK FOOTER //
// ./src/app/modules/create/getters.js